// TODO: displayName to become white-labelled
export const USER_GROUP_ROLES = [
	{
		name: 'Super Administrators' as const,
		displayName: 'Super Administrators',
	},
	{
		name: 'Admin' as const,
		displayName: 'Admin',
	},
	{
		name: 'Manager' as const,
		displayName: 'Manager',
	},
	{
		name: 'Staff' as const,
		displayName: 'Staff',
	},
	{
		name: 'InvoicedUser' as const,
		displayName: 'Invoiced User',
	},
	{
		name: 'FixedPriceUser' as const,
		displayName: 'Fixed Price User',
	},
	{
		name: 'User' as const,
		displayName: 'User',
	},
	{
		name: 'Guest' as const,
		displayName: 'Guest',
	},
	// {
	// 	name: 'Visitors' as const,
	// 	displayName: 'Visitors',
	// },
];

export type UserGroupRole = (typeof USER_GROUP_ROLES)[number]['name'];

export function isUserGroupRole(x: string): x is UserGroupRole {
	switch (x) {
		case 'Super Administrators':
		case 'Admin':
		case 'Manager':
		case 'Staff':
		case 'InvoicedUser':
		case 'FixedPriceUser':
		case 'User':
		case 'Guest':
			return true;
		default:
			return false;
	}
}

export const ROLE_PRIORITY: Record<UserGroupRole, number> = {
	'Super Administrators': 5,
	Admin: 4,
	Manager: 3,
	Staff: 2,
	User: 1,
	InvoicedUser: 1,
	FixedPriceUser: 1,
	Guest: 1,
};

/**
 * CAUTION: This will throw error if roles is empty.
 */
export function getHighestRole(roles: UserGroupRole[]): UserGroupRole {
	if (!roles.length) {
		throw new Error('Missing roles');
	}
	// Sort roles by priority descending and return the first
	return roles.sort((a, b) => {
		return ROLE_PRIORITY[b] - ROLE_PRIORITY[a];
	})[0];
}

export function getUserGroupRolesOnly(values: string[]): UserGroupRole[] {
	const roles: UserGroupRole[] = [];
	for (const value of values) {
		if (isUserGroupRole(value)) {
			roles.push(value);
		}
	}
	return roles;
}
